export default __webpack_public_path__ + "static/media/14.67715b1b.jpg";